/**
 * 获取用户 ID（从 cookie 读取或生成并持久化）
 * 用于播放记录、播放列表等 API 调用
 */
export const getUserId = () => {
  const cookies = document.cookie.split(';');
  for (let cookie of cookies) {
    const [name, value] = cookie.trim().split('=');
    if (name === 'user_id') return value;
  }
  const userId = 'user_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
  document.cookie = `user_id=${userId}; path=/; max-age=31536000`;
  return userId;
};
